import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"flex":"1"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, ":", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, ":", -1)
const _hoisted_4 = { style: {"padding":"20px"} }

import { t } from '@/plugins/i18n'
import { ref, onMounted, onUnmounted, watch } from 'vue'
import dayjs from 'dayjs'
import { QuestionFilled } from '@element-plus/icons-vue'
import { getJapanTime, getServiceTime2 } from '@/util/common'
// dealTime n天后自动处理

export default /*#__PURE__*/_defineComponent({
  props: ['time', 'dealTime'],
  setup(__props) {

const props = __props


const target = new Date(props.time).getTime() + 86400000 * props.dealTime
const targetTimeDesc = dayjs(getJapanTime(new Date(props.time).getTime() + 86400000 * props.dealTime)).format('YYYY-MM-DD HH:mm:ss')

const hour = ref('00')
const min = ref('00')
const sec = ref('00')
const isShow = ref(false)
const calcLessTime = () => {
  // 最终处理时间-中国时区
  const finalDealTime = new Date(props.time).getTime() + 24 * 60 * 60 * 1000 * props.dealTime
  // 当前时间-中国时区
  const nowTime = new Date(getServiceTime2(new Date())).getTime()
  if (nowTime + 24 * 60 * 60 * 1000 * 3 > finalDealTime && nowTime < finalDealTime) {
    const timeStamp = target - nowTime
    const hourNum = Math.floor(timeStamp / 3600000)
    hour.value = hourNum < 10 ? `0${hourNum}` : String(hourNum)
    const minNum = Math.floor((timeStamp - hourNum * 3600000) / 60000)
    min.value = minNum < 10 ? `0${minNum}` : String(minNum)
    const secNum = Math.floor((timeStamp - hourNum * 3600000 - minNum * 60000) / 1000)
    sec.value = secNum < 10 ? `0${secNum}` : String(secNum)
    clearTimeout(timer.value)
    timer.value = setTimeout(calcLessTime, 1000)
    isShow.value = true
    return
  }
  if (nowTime >= finalDealTime) {
    // 到期仍展示组件
    isShow.value = true
  } else {
    // 未到3天内不展示组件
    isShow.value = false
  }
  hour.value = '00'
  min.value = '00'
  sec.value = '00'
  clearTimeout(timer.value)
  timer.value = null
}

const observeTarget = ref()

const timer = ref()
watch(() => props.time, () => {
  clearTimeout(timer.value)
  timer.value = setTimeout(calcLessTime, 1000)
}, {
  immediate: true
})

onUnmounted(() => {
  clearTimeout(timer.value)
  timer.value = null
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (isShow.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: (_value, _refs) => {
          _refs['observeTarget'] = _value
          observeTarget.value = _value
        },
        class: "flex countdown"
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('自动处理剩余时间')), 1),
        _createElementVNode("div", null, _toDisplayString(hour.value), 1),
        _hoisted_2,
        _createElementVNode("div", null, _toDisplayString(min.value), 1),
        _hoisted_3,
        _createElementVNode("div", null, _toDisplayString(sec.value), 1),
        _createVNode(_component_el_popover, {
          placement: "top",
          width: "300",
          trigger: "hover",
          "popper-class": "",
          "popper-style": "border:none;border-radius: 8px;box-shadow: 0px 6px 12px 0px #ECECEC"
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_icon, { color: "#999" }, {
              default: _withCtx(() => [
                _createVNode(_unref(QuestionFilled))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, _toDisplayString(_unref(t)('问题生成时间')) + "：" + _toDisplayString(_unref(getJapanTime)(props.time)), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(t)('自动处理时间')) + "：" + _toDisplayString(_unref(targetTimeDesc)), 1)
            ])
          ]),
          _: 1
        })
      ], 512))
    : _createCommentVNode("", true)
}
}

})